import React, { useEffect, useState } from 'react'
import "./Chat.css";
import { useParams } from "react-router-dom";
import StarBorderedLine from "@material-ui/icons/StarBorderOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"
import db from './firebase';
import Message from './Message';
import ChatInput from './ChatInput';
function Chat() {
    const { roomid } = useParams();
    const [roomDetails, setRoomDetails] = useState();
    const [roomMessages, setRoomMessages] = useState([]);
    useEffect(() => {
        if (roomid){
            db.collection("Rooms").doc(roomid).onSnapshot(snapshot => (
                setRoomDetails(snapshot.data())
            ))

        }
        db.collection("Rooms").doc(roomid)
        .collection('messages')
        .orderBy("timestamp", 'asc')
        .onSnapshot(snapshot => 
            setRoomMessages(
                snapshot.docs.map(doc => doc.data())
            )
        )
    }, [roomid])
   console.log(roomMessages) 
    return (
        <div className="chat">
            
            <div className="chat__header">
                <div className="chat__headerLeft">
                    <h4 className="chat__channelName">
                        <strong>#{roomDetails?.name}</strong>
                        <StarBorderedLine />
                        
                    </h4>
                </div>
                <div className="chat__headerRight">
                <InfoOutlinedIcon /> Details
                </div>
                
            </div>
            <div className="chat__messages">
                {roomMessages.map((message) => (
                    <Message timestamp={message.timestamp} message={message.message} user={message.user} userImage={message.userImage} />
                ))}
            </div>
            <ChatInput channelName={roomDetails?.name} channelId = {roomid} /> 
        </div>
        
    )
}

export default Chat

